import { render, staticRenderFns } from "./edgeServer.vue?vue&type=template&id=05f7d402&scoped=true&"
import script from "./edgeServer.vue?vue&type=script&lang=js&"
export * from "./edgeServer.vue?vue&type=script&lang=js&"
import style0 from "./edgeServer.vue?vue&type=style&index=0&id=05f7d402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f7d402",
  null
  
)

export default component.exports